@if (style() === 'vertical') {
  <div class="flex flex-row mdr:gap-x-4">
    <div class="mt-4 mdr:flex">
      @if (hideMobileTabs()) {
        <div class="-ml-4 flex h-50 mdr:hidden" (click)="triggerMobileTabs(true)" vtiSwipe (swipeRight)="triggerMobileTabs(true)">
          <vti-icons class="m-auto" [icon]="'tab'" size="8" color="vti"></vti-icons>
        </div>
      } @else {
        <div class="relative z-50 mdr:hidden">
          <div class="fixed inset-0 bg-gray-900/80"></div>
          <div class="fixed inset-x-0 inset-y-44 flex">
            <div class="relative flex w-full max-w-min flex-1">
              <div class="flex grow gap-y-5 overflow-y-auto bg-white px-6 pb-4 rounded-md">
                <div class="flex-col grow">
                  <nav class="flex flex-1 flex-col">
                    <ul role="list" class="flex flex-1 flex-col mt-4 gap-y-7">
                      @for (tab of tabs; track $index) {
                        <li>
                          <div
                            class="group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold cursor-pointer"
                            [ngClass]="currentTabIndex() === tab.index() ? 'bg-gray-50 text-vti-600' : 'text-gray-700 hover:text-vti-600 hover:bg-gray-50'"
                            (click)="setCurrentTab(tab.index())"
                          >
                            <span> {{ tab.name() }} </span>
                          </div>
                        </li>
                      }
                    </ul>
                  </nav>
                </div>
                <div class="flex h-full w-10" (click)="triggerMobileTabs(false)" vtiSwipe (swipeLeft)="triggerMobileTabs(false)">
                  <vti-icons class="m-auto" [icon]="'tab'" size="8" color="vti"></vti-icons>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <div class="hidden mdr:z-50 mdr:flex mdr:w-44 mdr:grow">
        <div class="flex grow gap-y-5 overflow-y-auto border-r border-gray-200 bg-white pb-4">
          <nav class="flex flex-1">
            <ul role="list" class="flex flex-1 flex-col gap-y-2">
              @for (tab of tabs; track $index) {
                <li>
                  <div
                    class="group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold cursor-pointer"
                    [ngClass]="currentTabIndex() === tab.index() ? 'bg-gray-50 text-vti-600' : 'text-gray-700 hover:text-vti-600 hover:bg-gray-50'"
                    (click)="setCurrentTab(tab.index())"
                  >
                    <span> {{ tab.name() }} </span>
                  </div>
                </li>
              }
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="currentTab()"></ng-container>
  </div>
} @else {
  <div class="ml-4 flex">
    <div class="block ml-2 w-full">
      <div class="border-b border-gray-200 pb-2">
        <nav class="-mb-px flex">
          <ul role="list" class="flex flex-1 flex-row gap-y-2">
            @for (tab of tabs; track $index) {
              <li>
                <div
                  class="group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold cursor-pointer w-24 justify-center"
                  [ngClass]="currentTabIndex() === tab.index() ? 'bg-gray-50 text-vti-600' : 'text-gray-700 hover:text-vti-600 hover:bg-gray-50'"
                  (click)="setCurrentTab(tab.index())"
                >
                  <span> {{ tab.name() }} </span>
                </div>
              </li>
            }
          </ul>
        </nav>
      </div>
      <ng-container *ngTemplateOutlet="currentTab()"></ng-container>
    </div>
  </div>
}
